<template>
    <singleService ref="singleServicePopupRef" :serviceData="singleServiceData" />
    <div class="componentWrapper">
        <div class="serviceBoxes">
            <div class="singleBox" v-for="element of services" :key="element.id">
                <img 
                    :src="require('../../assets/icons/'+element.icon)" 
                    alt=""
                >
                <h2>{{element.title}}</h2>
                <p>{{element.text}}</p>
                <!-- <Button @click="openServicePopup(element)" icon="pi pi-external-link" style="color: steelblue; border: 1px solid steelblue;" rounded severity="info" :label="element.btnLabel" outlined /> -->
            </div>
        </div>
        <div class="texts">
            <span>{{$t('services.smallTitle', currentLang)}}</span>
            <h1>{{$t('services.title', currentLang)}}</h1>
            <p v-html="$t('services.text', currentLang)"></p>
            <Button 
                style="height: 60px; width: 180px; background-color: steelblue; border: 1px solid steelblue;" 
                :label="$t('buttons.contactUs', currentLang)"
                @click="$emit('openContactPopup')" 
                icon="pi pi-phone"  
                severity="contrast"  
            />
        </div>
    </div>
</template>
  
<script>
import singleService from '@/components/popup/singleService.vue';
import Button from 'primevue/button';
export default {
    name: 'ourServices',
    components: {
        Button,
        singleService
    },
    data() {
        return {
            singleServiceData: null,
        };
    },
    computed: {
        services() {
            // Fetch the references from the current language JSON file
            return this.$t('services.servicesList', this.currentLang);
        },        currentLang() {
            return this.$route.params.lang || 'et'; // Default to 'et' if no lang param
        }
    },
    methods: {
        openServicePopup(element) {
            this.$refs.singleServicePopupRef.visible = true
            this.singleServiceData = element
        }
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>

<style scoped>
.componentWrapper {
    position: relative;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.serviceBoxes {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    min-width: 680px;
    -webkit-column-gap: 20px;
       -moz-column-gap: 20px;
            column-gap: 20px;
    row-gap: 20px;
    margin-top: 100px;
}
.singleBox {
    background: white;
    width: 330px;
    height: 250px;
    -webkit-box-shadow: 10px 41px 57px -17px rgba(0, 0, 0, 0.22);
            box-shadow: 10px 41px 57px -17px rgba(0, 0, 0, 0.22);
    text-align: center;
    padding-left: 25px;
    padding-right: 25px;
    border-radius: 20px;
}
.singleBox h2 {
    font-size: 20px;
    font-family: "Inter", sans-serif;
    color: #243757;
    font-weight: 700;
}
.singleBox p {
    color: rgb(100,100,100);
    margin-bottom: 15px;
}
.singleBox img {
    width: 60px;
    height: 60px;
    margin-top: 25px;
    text-align: center;
}
.texts {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 100px;
    margin-top: 130px;
}
.texts h1 {
    margin: 0;
    margin-top: 15px;
    margin-bottom: 25px;
    font-size: 2.7rem;
}
.texts span {
    font-family: "Inter", sans-serif;
    color: #94a2b9;
    font-weight: 700;
}
.texts p {
    color: #3a5a75;
    font-size: 18px;
    margin-bottom: 40px;
}

@media (max-width: 1200px) {
    .componentWrapper {
        flex-direction: column;
    }
    .serviceBoxes {
        order: 1;
        margin-top: 50px;
    }
    .texts {
        width: 100%;
        order: 0;
        padding: 0;
    }
}
@media (max-width: 720px) {
    .serviceBoxes {
        min-width: 100%;
    }
}
@media (max-width: 450px) {
    .header {
        flex-wrap: wrap;
    }
    .stars {
        order: 1;
    }
    .header img {
        margin-bottom: 5px;
    }
    .feedbackContainer {
        padding: 25px;
    }
}
@media (max-width: 500px) {
    .texts h1 {
        font-size: 8vw;
    }
    .texts {
        margin-top: 40px;
    }
}
</style>